import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@material-ui/core/SvgIcon';
import { withTheme } from '@material-ui/core/styles';

const IconRural = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 24 24">
    <path d="M6 6L0 12V22H5V17H7V22H12V12L6 6ZM7 15H5V13H7V15Z" />
    <path d="M21.9 12H19.9L23.9 18H16.88V22H12.92V11.5L10 8.5L14.9 2L21.9 12Z" fill={theme.palette.notification[700]} />
  </SvgIcon>
);

IconRural.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      notification: PropTypes.shape({
        700: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconRural);



// WEBPACK FOOTER //
// ./src/components/icons/IconRural.js